/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Terms_MsgInputs */

const es_cap_err_terms_msg = /** @type {(inputs: Cap_Err_Terms_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar los términos y la política de privacidad.`)
};

const gl_cap_err_terms_msg = /** @type {(inputs: Cap_Err_Terms_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes aceptar os termos e a política de privacidade.`)
};

const en_cap_err_terms_msg = /** @type {(inputs: Cap_Err_Terms_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the terms and privacy policy.`)
};

/**
* | output |
* | --- |
* | "You must accept the terms and privacy policy." |
*
* @param {Cap_Err_Terms_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_terms_msg = /** @type {((inputs?: Cap_Err_Terms_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Terms_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_terms_msg(inputs)
	if (locale === "en") return en_cap_err_terms_msg(inputs)
	return es_cap_err_terms_msg(inputs)
});